import { Component, ViewChild } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { DatagridService, PagedResultGeneric, PagedSearch, PagedResult, NotificationService } from 'src/app/shared';
import { DialogService } from '../../shared/index';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { VerticalNahbService } from '../../vertical/nahb/shared/vertical-nahb.service';
import { HbaNahbBatchDto } from '../../vertical/nahb/shared/dto/hba-nahb-batch.dto';
import { HbaNahbExportDto } from '../../vertical/nahb/shared/dto/hba-nahb-export.dto';
import { HbaNahbExportValidationDto } from 'src/app/vertical/nahb/shared/dto/hba-nahb-validation.dto';
import { NahbExportValidationModalComponent } from './nahb-export-validation-modal/nahb-export-validation-modal.component';

@Component({
  selector: 'wl-nahb-export',
  templateUrl: './nahb-export.component.html',
  styleUrl: './nahb-export.component.less',
    standalone: false
})
export class NAHBExportComponent extends LazySelectableTableComponent<PagedSearch, HbaNahbExportDto> {
  @ViewChild(NahbExportValidationModalComponent) private _validationIssuesDialog: NahbExportValidationModalComponent;

  // The api Vertical/Hba/Nahb/Changes is broken, so cannot fetch the the NahbExportResult as a whole set
  // However, we are able to fetch the changes by batch ID

  lastExportBatchDate: Date;
  lastExportBatchId: number;
  exporting: boolean = false;
  validationIssues: Array<HbaNahbExportValidationDto> = [];
  constructor(
    datagridService: DatagridService,
    private _verticalNahbService: VerticalNahbService,
    private _notificationService: NotificationService
  ) {
    super('', datagridService);
    this.searchResult = { PageSize: 20, CurrentPageNumber: 1 } as PagedResultGeneric<HbaNahbExportDto>;
    this.searchParams = { PageNumber: 1, PageSize: 20 } as PagedSearch;
  }

  async ngOnInit() {
    await this.getLastBatchDate();
    this.search();
  }

  async getLastBatchDate() {
    try {
      await this._verticalNahbService.getHbaLastNahbBatch().then((data: HbaNahbBatchDto) => {
        this.lastExportBatchDate = data.BatchDate;
        this.lastExportBatchId = data.Id;
      });
    } catch (error) {
      console.error('Error fetching last batch number', error);
    }
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  fetchResults(): Promise<PagedResultGeneric<HbaNahbExportDto>> {
    return this._verticalNahbService.getNahbChanges().then((results) => {
      this.validationIssues = results.ValidationIssues;
      const startIndex = (this.searchParams.PageNumber - 1) * this.searchParams.PageSize;
      const endIndex = startIndex + this.searchParams.PageSize;

      const pagedData = results.Results.slice(startIndex, endIndex);

      const PagedResult: PagedResultGeneric<HbaNahbExportDto> = {
        Result: pagedData,
        TotalCount: results.Results.length,
        TotalPages: Math.ceil(results.Results.length / this.searchParams.PageSize),
        CurrentPageNumber: this.searchParams.PageNumber,
        PageSize: this.searchParams.PageSize,
      };

      return PagedResult;
    });
  }

  exportResults() {
    this.exporting = true;
    this._verticalNahbService
      .exportNahbProfileChanges()
      .then((message) => {
        this._notificationService.success(message);
      })
      .finally(() => {
        this.exporting = false;
      });
  }

  openValidationModal() {
    this._validationIssuesDialog.open();
  }
}
